import { render } from "./FormLowongan.vue?vue&type=template&id=0a3bde7c"
import script from "./FormLowongan.vue?vue&type=script&lang=js"
export * from "./FormLowongan.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__